module.exports = __webpack_public_path__ + "img/xrplorg-explorer.4c5e6faa.gif";